
import { mapState } from 'vuex'
import { useDispatchStoreAction } from '~/mixins/DispatchStoreAction'

export default {
  mixins: [
    useDispatchStoreAction({
      action: 'user/sendPasswordResetLink',
    }),
  ],

  data() {
    return {
      form: {
        email: '',
      },

      success: false,
      hasSubmitted: false,
      error: null,
    }
  },

  head() {
    return {
      title: this.$t('forgot-password'),
    }
  },

  computed: {
    ...mapState('global', ['resetPasswordPageSettings']),
  },

  methods: {
    async createResetLink() {
      this.hasSubmitted = true
      this.error = null
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      try {
        this.$toast.show(this.$t('process-reset-link'))

        await this.dispatchStoreAction(this.form.email, {
          silentOnSuccess: true,
          silentOnError: true,
        })

        this.$toast.clear()
        this.$toast.success(this.$t('reset-link-sent'))
        this.success = true
      } catch (error) {
        this.$toast.clear()
        this.error = error?.response?.data?.message
          ? error.response.data.message
          : error
      }
    },
  },
}
